/**
 * A plan cached in `pendingPlanRef` (guest picks a plan -> signs in -> resumes)
 * may have been captured before `hasPhotoshootHandoffOrigin()`/`userHadAFreeTrial`
 * was known, and is never re-validated against trial gating when restored.
 * Refuse to trust a cached yearly slot that still allows a trial once
 * withholding applies -- callers should fall back to the already-gated
 * planDetail already in state (seeded via getFallbackPlanDetail /
 * SignInManager.getPlanPrices, both of which are trial-gating-aware) instead.
 */
export function sanitizeCachedPlanDetailForTrialGating<
  T extends { year?: { canFreeTrial?: boolean; trialDays?: number } } | null | undefined,
>(cachedPlanDetail: T, shouldWithholdYearlyTrial: boolean): T {
  if (!shouldWithholdYearlyTrial || !cachedPlanDetail) return cachedPlanDetail
  const cachedYearAllowsTrial =
    Boolean(cachedPlanDetail.year?.canFreeTrial) || (cachedPlanDetail.year?.trialDays ?? 0) > 0
  return cachedYearAllowsTrial ? (null as T) : cachedPlanDetail
}
